import React, { useState } from "react";
import {
    Button,
    Box,
    Heading,
    VStack,
    Text,
    Skeleton
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FormPassword } from "../FormPassword";

const MotionBox = motion(Box);

export const NewPassword = ({
    newPassword,
    newPasswordAgain,
    isPasswordError,
    isRepeatPasswordError,
    isLoading,
    onPasswordChange,
    onNewPasswordSubmit,
    showPassword,
    toggleShowPassword,
    isSkeletonLoading
}) => {
    const [userNewPassword, setUserNewPassword] = useState(newPassword);
    const [userRepeatPassword, setUserRepeatPassword] =
        useState(newPasswordAgain);
    return (
        <Box sx={{ width: "100%" }}>
            {isSkeletonLoading ? <Skeleton height="1.5em" width="20%" mx="auto" /> :
                <Text className='logo' sx={{ margin: "0 0 20px", textAlign: "center" }}>EdShopify</Text>}
            <MotionBox
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                maxW="md"
                mx="auto"
                p={{ base: 0, sm: 6 }}
                borderWidth={{ base: "none", sm: "1" }}
                borderRadius={{ base: "none", sm: "lg" }}
                shadow={{ base: "none", sm: "lg" }}
                sx={{
                    minWidth: { base: "100%", sm: "400px" }
                }}
            >
                <VStack
                    spacing={5}
                >
                    <Skeleton isLoaded={!isSkeletonLoading}>
                        <Heading fontSize={"2xl"}>Enter new password</Heading>
                    </Skeleton>

                    {isSkeletonLoading ? (
                        <VStack spacing={4} w="100%">
                            <Box m="0 0 20px" w="100%">
                                <Skeleton height="1em" w="100%" m="0 0 10px" />
                                <Skeleton height="40px" w="100%" />
                            </Box>
                            <Box m="0 0 20px" w="100%">
                                <Skeleton height="1em" w="100%" m="0 0 10px" />
                                <Skeleton height="40px" w="100%" />
                            </Box>
                            <Skeleton height="40px" w="100%" />
                        </VStack>
                    ) : (
                        <form onSubmit={onNewPasswordSubmit} style={{ width: "100%" }}>
                            <VStack
                                spacing={5}
                            >
                                <FormPassword
                                    label="New Password"
                                    name="new_password"
                                    showPassword={showPassword}
                                    toggleShowPassword={toggleShowPassword}
                                    placeholder=""
                                    inputOnChange={(e) => {
                                        onPasswordChange(e);
                                        setUserNewPassword(e.target.value);
                                    }}
                                    value={userNewPassword}
                                    formProps={{ isRequired: true, isInvalid: isPasswordError }}
                                    inputProps={{ disabled: isLoading }}
                                    padding="0 0 20px"
                                    errorMessage={
                                        <>
                                            <Text
                                                color={/[a-z]/.test(newPassword) ? "green.500" : "red.500"}
                                            >
                                                Password must contain a lower case letter.
                                            </Text>
                                            <Text
                                                color={/[A-Z]/.test(newPassword) ? "green.500" : "red.500"}
                                            >
                                                Password must contain an upper case letter.
                                            </Text>
                                            <Text
                                                color={
                                                    /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(newPassword)
                                                        ? "green.500"
                                                        : "red.500"
                                                }
                                            >
                                                Password must contain a special character.
                                            </Text>
                                            <Text color={/\d/.test(newPassword) ? "green.500" : "red.500"}>
                                                Password must contain a number.
                                            </Text>
                                            <Text color={newPassword.length >= 8 ? "green.500" : "red.500"}>
                                                Password must contain at least 8 characters.
                                            </Text>
                                        </>
                                    }
                                />
                                <FormPassword
                                    label="Enter New Password Again"
                                    name="new_password_again"
                                    showPassword={showPassword}
                                    toggleShowPassword={toggleShowPassword}
                                    placeholder=""
                                    inputOnChange={(e) => {
                                        onPasswordChange(e);
                                        setUserRepeatPassword(e.target.value);
                                    }}
                                    value={userRepeatPassword}
                                    formProps={{ isRequired: true, isInvalid: isRepeatPasswordError }}
                                    inputProps={{ disabled: isLoading }}
                                    padding="0 0 20px"
                                    errorMessage={"Your password should match with the above one."}
                                />
                                <Button
                                    width="full"
                                    colorScheme="blue"
                                    _hover={{
                                        bg: "blue.500",
                                    }}
                                    type="submit"
                                    isLoading={isLoading}
                                    loadingText="Creating password"
                                >
                                    Create Password
                                </Button>
                            </VStack>
                        </form>
                    )}
                </VStack>
            </MotionBox>
        </Box>
    );
};
